import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost } from '@/lib/api';
import { pricebookKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import { usePricebookApi } from './usePricebookApi';

/**
 * NOT-105: Restore (un-archive) a previously archived pricebook line item.
 * Flips status ARCHIVED → ACTIVE on the server; the row already exists in
 * the DB. The companion of {@link useArchiveItem}.
 */
export function useRestoreItem() {
  const queryClient = useQueryClient();
  const { client, ep } = usePricebookApi();

  return useApiMutation<unknown, string>({
    mutationFn: (id) => apiPost(client, ep.restore(id), {}),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pricebookKeys.all() });
      toast.success('Item restored');
    },
  });
}
